"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsiblePanel = CollapsiblePanel;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CollapsiblePanelContext = require("../contexts/CollapsiblePanelContext");

var _VerticalFlex = require("./VerticalFlex");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function CollapsiblePanel(props) {
  var panelClass = props.isCollapsed ? 'collapsible-panel collapsible-panel--collapsed' : 'collapsible-panel';
  return (
    /*#__PURE__*/
    _react["default"].createElement(_CollapsiblePanelContext.CollapsiblePanelContextProvider, {
      isCollapsed: props.isCollapsed,
      onCollapse: props.onCollapse
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: panelClass
    },
    /*#__PURE__*/
    _react["default"].createElement(_VerticalFlex.VerticalFlex, null, props.children)))
  );
}

CollapsiblePanel.propTypes = {
  children: _propTypes["default"].node.isRequired,
  isCollapsed: _propTypes["default"].bool.isRequired,
  onCollapse: _propTypes["default"].func.isRequired
};